export class AccountRoutingRouteNames {
    public static readonly Login = 'login';
    public static readonly SignUpRegistration = 'sign-up-registration';
    public static readonly SignUpInvitation = 'sign-up-invitation';
    public static readonly SignUpEmailConfirmation = 'sign-up-email-confirmation';

    // TODO: those are legacy and can be deleted once legacy is being deleted
    public static readonly PmsRegistrationSetInitialPassword = 'pms-registration-set-initial-password';
    public static readonly RegistrationEmailConfirmationPending = 'registration-email-confirmation-pending';
    public static readonly RegistrationEmailConfirmationPendingParamId = 'email';
    public static readonly TermsOfUse = 'terms-of-use';
    public static readonly RegistrationConfirmationSuccess = 'registration-confirmation-success';
    // END OF LEGACY

    public static readonly RegistrationConfirmationVerifyLink = 'verify-link/registration';
    public static readonly ResetPassword = 'reset-password';
    public static readonly ResetPasswordSend = 'reset-password-send';
    public static readonly ResetPasswordVerifyLink = 'verify-link/reset-password';
    public static readonly ResetPasswordVerification = 'reset-password-verification';
    public static readonly UpdateEmailLinkVerify = 'verify-link/email-update';
    public static readonly UpdateEmailVerification = 'update-email-verification';
    public static readonly DeleteAccount = 'delete-account';
    public static readonly ObjectToInvitation = 'delete-invitation';

    public static readonly AppointmentRegistrationStart = 'appointment-registration-start';
    public static readonly externalVeterinarianIdParam = 'externalVetId';
    public static readonly veterinarianBranchParam = 'branch';
    public static readonly NoRegistrationParam = 'noRegistration';

    public static readonly AppointmentRegistrationSuccess = 'appointment-registration-success';
    public static readonly AppointmentReservationProcessOutlet = 'outlet-appointment-reservation-process';
    public static readonly AppointmentReservationProcessRoutes = {
        AgreeToEulaAndPrivacy: 'agree-to-eula-and-privacy',
        AppointmentReservationSuccess: 'appointment-reservation-success',
        AppointmentReservationSummary: 'appointment-reservation-summary',
        AppointmentReservationRequest: 'appointment-reservation-request',
        Completed: 'completed',
        EnterAddressData: 'enter-address-data',
        EnterEmailAndPassword: 'enter-email-and-password',
        EnterPatientData: 'enter-patient-data',
        EnterPersonalData: 'enter-personal-data',
        PickAppointmentSlot: 'pick-appointment-slot',
        PickNumberOfPatients: 'pick-number-of-patients',
    };

    public static readonly SelfCheckInRegistrationStart = 'self-check-in-start';
    public static readonly SelfCheckInWithRegistrationSuccess = 'self-check-in-with-registration-success';
    public static readonly SelfCheckInWithoutRegistrationSuccess = 'self-check-in-without-registration-success';
    public static readonly SelfCheckInRegistrationProcessOutlet = 'outlet-self-check-in-process';
    public static readonly SelfCheckInRegistrationProcessRoutes = {
        PickNumberOfPatients: 'pick-number-of-patients',
        EnterPersonalData: 'enter-personal-data',
        EnterAddressData: 'enter-address-data',
        EnterPatientData: 'enter-patient-data',
        DecideToRegister: 'decide-to-register',
        EnterEmailAndPassword: 'enter-email-and-password',
        AgreeToEulaAndPrivacy: 'agree-to-eula-and-privacy',
        Completed: 'completed',
        Error: 'error',
    };

    public static readonly VeterinarianLinkageRequestRegistrationStart = 'veterinarian-linkage-request-start';
    public static readonly VeterinarianLinkageRequestWithRegistrationSuccess = 'veterinarian-linkage-request-with-registration-success';
    public static readonly OnlineCheckInWithRegistrationSuccess = 'online-check-in-with-registration-success';
    public static readonly OnlineCheckInStart = 'online-check-in-start';
}
